// Dependency-free notification signal. Fire this whenever notifications change
// out-of-band (e.g. an admin seeds one) so the nav badge updates without a
// navigation/remount. Kept separate from NotificationsContext so non-React /
// router-free modules can import it cheaply.
export const NOTIFICATIONS_CHANGED_EVENT = 'b4w:notifications-changed';

export function emitNotificationsChanged() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(NOTIFICATIONS_CHANGED_EVENT));
  }
}
